import request from '@/utils/request'

// 分页查询银河打本店铺用户关系
export function pageUserShopRelation(query) {
  return request({
    url: '/user/played/shop/relation/pageUserShopRelation',
    method: 'get',
    params: query
  })
}

// 管理后台设置门店管理员
export function adminSetShopManager(data) {
  return request({
    url: '/user/played/shop/relation/adminSetShopManager',
    method: 'put',
    data: data
  })
}
